import { observable, action, runInAction } from 'mobx'
import { StoreExt } from '@utils/reactExt'
import { roles } from '@services/api'

export class roleStore extends StoreExt {
    @observable roles = []
    @observable slugs = {}

    @action
    getAllRoles = async () => {
        roles.getAllRoles()
        .then((res) => {
            runInAction(() => {
                this.roles = res.data
                res.data.forEach((role) => this.slugs[role.slug] = role.name)
            })
        })

    }
}

export default new roleStore()
